import PropTypes from 'prop-types';


import * as contentConstants from '../Content/contentConstants';

import {listConstants} from '../List';



// ------ import job

export const IMPORT_JOB_STATUS_COMPLETE = 'complete';
export const IMPORT_JOB_STATUS_CREATE = 'create';
export const IMPORT_JOB_STATUS_FINISH = 'finish';
export const IMPORT_JOB_STATUS_ERROR = 'error';
export const IMPORT_JOB_STATUS_LOAD = 'load';
export const IMPORT_JOB_STATUS_NEW = 'new';
export const IMPORT_JOB_STATUS_PROCESS = 'process';
export const IMPORT_JOB_STATUS_TRANSFORM = 'transform';

export const IMPORT_JOB_STATUSES = [
    IMPORT_JOB_STATUS_COMPLETE,
    IMPORT_JOB_STATUS_CREATE,
    IMPORT_JOB_STATUS_FINISH,
    IMPORT_JOB_STATUS_ERROR,
    IMPORT_JOB_STATUS_LOAD,
    IMPORT_JOB_STATUS_NEW,
    IMPORT_JOB_STATUS_PROCESS,
    IMPORT_JOB_STATUS_TRANSFORM
];


// ------ nav

export const NAV_MY_BASE = '/my';

export const NAV_MY_ACCOUNT = `${NAV_MY_BASE}/account`;

export const NAV_MY_CONTENT = `${NAV_MY_BASE}/content`;

export const NAV_MY_CONTENT_ADD_ENTITY = `${NAV_MY_BASE}/content/add/entity`;

export const NAV_MY_ORDERS = `${NAV_MY_BASE}/orders`;

export const NAV_MY_PROFILE = `${NAV_MY_BASE}/profile`;

export const NAV_MY_SETTINGS = `${NAV_MY_BASE}/settings`;


// export const NAV_ENTRY_ID_ACCOUNT = 'account';
export const NAV_ENTRY_ID_CONTENT = 'content';
export const NAV_ENTRY_ID_ORDERS = 'orders';


// list of my navigation
export const MY_NAV_ENTRIES = [
    // {
    //     id: NAV_ENTRY_ID_ACCOUNT,
    //     path: NAV_MY_ACCOUNT
    // },
    {
        id: NAV_ENTRY_ID_CONTENT,
        path: NAV_MY_CONTENT
    },
    {
        id: NAV_ENTRY_ID_ORDERS,
        path: NAV_MY_ORDERS
    }
];



// ------ shapes
const SHAPE_MY_CONTENT_LIST_ITEM = {
    ...contentConstants.SHAPE_CONTENT_AUTHORS,
    department: PropTypes.string.isRequired,
    distribution: PropTypes.shape(contentConstants.SHAPE_CONTENT_DISTRIBUTION).isRequired,
    externalId: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    originalLanguage: PropTypes.string.isRequired,
    originalTitle: PropTypes.string.isRequired,
    salesCount: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    wordCount: PropTypes.number.isRequired
};


export const SHAPE_MY_CONTENT_LIST_RESULT = {
    ...listConstants.SHAPE_LIST_ROOT,
    items: PropTypes.arrayOf(
        PropTypes.shape(SHAPE_MY_CONTENT_LIST_ITEM)
    ).isRequired,
    isEmpty: PropTypes.bool.isRequired
};


const SHAPE_MY_ORDER_LIST_ITEM = {
    customerPoNumber: PropTypes.string,
    id: PropTypes.string.isRequired,
    orderDate: PropTypes.string.isRequired,
    orderNumber: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    totalGrossPrice: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired
};


export const SHAPE_MY_ORDER_LIST_RESULT = {
    ...listConstants.SHAPE_LIST_ROOT,
    items: PropTypes.arrayOf(
        PropTypes.shape(SHAPE_MY_ORDER_LIST_ITEM)
    ).isRequired,
    isEmpty: PropTypes.bool.isRequired
};
